import React, {useState, useEffect, useRef} from 'react';
import {Button, Tag, Space, Modal, notification, Typography, Card} from 'antd';
import RuleModal from '@/page/admin/InterceptRulePage/RuleModal';
import {PageGrid} from '@/component';
import _ from 'lodash';
import {delIntercept} from '@/api/sensitive';
import {PlusOutlined} from '@/icons';

export default function RuleTable({editable}) {
    const [url, setUrl] = useState(null);
    const modalRef = useRef();
    const tableRef = useRef();
    useEffect(() => {
        setUrl('/sensitive/intercept/list');
    }, []);
    const extra = (
        <Button type="primary" icon={<PlusOutlined />} onClick={onAddClick} disabled={!editable}>
            添加
        </Button>
    );
    const columns = [
        {
            title: '规则名称',
            dataIndex: 'name',
        },
        {
            title: '敏感词',
            dataIndex: 'match',
            render: match => {
                let matchs = match.split(',');
                return matchs.map((item, i) => <Tag key={i}>{item}</Tag>);
            },
        },
        {
            title: '拦截方式',
            dataIndex: 'interceptType',
            render: interceptType => (
                <>
                    {interceptType === 1 && <Tag color="#f50">警告并拦截发送</Tag>}
                    {interceptType === 2 && <Tag color="#ff8000">仅发警告</Tag>}
                    {interceptType === 3 && <Tag color="#cccc10">仅触发通知</Tag>}
                </>
            ),
        },
        {
            title: '提醒邮箱',
            dataIndex: 'email',
            render: email => {
                if (_.isEmpty(email)) {
                    return '/';
                } else {
                    let emials = email.split(',');
                    return emials.map((item, i) => <Tag key={i}>{item}</Tag>);
                }
            },
        },
        {
            title: '其他',
            dataIndex: 'semanticsList',
            render: semanticsList => {
                if (_.isEmpty(semanticsList)) {
                    return '无';
                } else {
                    let semantics = semanticsList.split(',');
                    return semantics.map((item, i) => (
                        <Tag key={i}>
                            {item === '1' && '手机号'}
                            {item === '2' && '邮箱地'}
                            {item === '3' && '红包'}
                        </Tag>
                    ));
                }
            },
        },
        {
            title: '操作',
            dataIndex: 'action',
            render: (text, record) => (
                <Space>
                    <a onClick={() => onView(record)}>查看</a>
                    <a onClick={() => onEdit(record)} disabled={!editable}>
                        编辑
                    </a>
                    <a onClick={() => onDeleteClick(record)} disabled={!editable}>
                        删除
                    </a>
                </Space>
            ),
        },
    ];

    function onAddClick() {
        modalRef.current.open(false);
    }

    function onView(record) {
        modalRef.current.open(false, record);
    }

    function onEdit(record) {
        modalRef.current.open(true, record);
    }

    function reload() {
        tableRef.current.reload2FirstPage({});
    }

    function onDeleteClick(record) {
        console.log(record);
        const content = <p>确定删除 [{record.name}]？</p>;

        Modal.confirm({
            title: '警告',
            content,
            okButtonProps: {danger: true},
            onOk: () => {
                delIntercept(record.ruleId).then(() => {
                    notification.success({
                        message: '删除成功',
                    });
                    reload();
                });
            },
        });
    }

    return (
        <>
            <Card 
                title="拦截规则管理"
                extra={extra} 
                style={{height: 'calc(100vh - 200px)', overflowY: 'auto'}}
            >
                {url && (
                    <PageGrid 
                        url={url} 
                        columns={columns} 
                        ref={tableRef}
                        tableProps={{
                            scroll: { y: 'calc(100vh - 320px)' }
                        }}
                    />
                )}
            </Card>
            <RuleModal ref={modalRef} reload={reload} />
        </>
    );
}
